/* unplugin-vue-components disabled */import script from "./lawyers.vue?vue&type=script&setup=true&lang=js"
export * from "./lawyers.vue?vue&type=script&setup=true&lang=js"

import "./lawyers.vue?vue&type=style&index=0&id=51d8e8d1&lang=scss&scoped=true"
import "./lawyers.vue?vue&type=style&index=1&id=51d8e8d1&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.12_vue@3.5.12_webpack@5.96.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51d8e8d1"]])

export default __exports__